export default "__VITE_ASSET__CJNImLbH__"